import { Column, Entity, Index, OneToMany } from 'typeorm';
import { BaseEntity } from './base.entity';
import { DashboardWidgetEntity } from './dashboard-widget.entity';

/**
 * Which dashboard surface a widget belongs to. Used by the widget
 * selector / picker to filter the catalog so admins editing a CRM
 * dashboard see only CRM widgets, and admins editing a storefront
 * design see only STOREFRONT widgets. Storefront ≠ CRM, ever — no
 * `BOTH` value exists.
 */
export type ReportsRegistrySurface = 'CRM' | 'STOREFRONT';

@Index('idx_active', ['isActive'], {})
@Index('idx_category', ['category'], {})
@Index('idx_module', ['module'], {})
@Index('idx_report_key', ['reportKey'], {})
@Index('idx_surface', ['surface'], {})
@Index('reportKey', ['reportKey'], { unique: true })
@Entity('reports_registry')
export class ReportsRegistryEntity extends BaseEntity {
	@Column('varchar', { name: 'reportKey', unique: true, length: 100 })
	public reportKey!: string;

	@Column('varchar', { name: 'name', length: 255 })
	public name!: string;

	@Column('text', { name: 'description', nullable: true })
	public description!: string | null;

	@Column('varchar', { name: 'module', length: 100 })
	public module!: string;

	@Column('varchar', { name: 'category', length: 50 })
	public category!: string;

	@Column('varchar', { name: 'reportPath', length: 255 })
	public reportPath!: string;

	@Column('varchar', { name: 'componentName', length: 100 })
	public componentName!: string;

	@Column({
		type: 'boolean',
		name: 'isActive',
		nullable: true,
		width: 1,
		default: () => "'1'",
	})
	public isActive!: boolean | null;

	/**
	 * Defaults to `CRM` so existing rows behave as before — every
	 * report widget that exists today is a CRM widget. Storefront-
	 * specific widgets (promo banner, carousel, grid, etc.) are
	 * registered with `surface = 'STOREFRONT'`.
	 */
	@Column('varchar', {
		name: 'surface',
		length: 16,
		default: () => "'CRM'",
	})
	public surface!: 'CRM' | 'STOREFRONT';

	@OneToMany(
		() => DashboardWidgetEntity,
		(dashboardWidget) => dashboardWidget.fkReportsRegistry,
		{},
	)
	public dashboardWidgets!: Array<DashboardWidgetEntity>;
}
